import axios from "axios";
import { Urls } from "../../slices/urls";
import { RegisterServiceUrls, BackEndServiceUrls } from "../../../store/serviceUrl";

export const getSignupFieldsDropdownRepo = (params) => {
  return axios({
    baseURL:
      RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_REGISTRATION_SIGNUP_DROPDOWN_FIELDS,
    params: params,
  });
};

export const getipinfoLocationRepo = (params) => {
  return axios({
    baseURL: RegisterServiceUrls.GET_IPINFO_LOCATION,
    method: "GET",
    params: params,
    withCredentials: false,
  });
};

export const postLoginSignupOtpRepo = (data) => {
  return axios({
    baseURL:
      RegisterServiceUrls.REGISTER_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_REGISTRATION_LOGIN_OTP_API,
    data: data,
  });
};




export const getUserAuthenticationpRepo = (params) => {
  return axios({
    baseURL:
      RegisterServiceUrls.REGISTER_SERVICE +
      axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_REGISTRATION_USER_AUTHENTICATION_API,
    params: params,
  });
};

export const getManageContentRepo = (params) => {
  return axios({
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_REGISTRATION_MANAGE_CONTENT_API,
    params: params,
  })
}

export const getIpAddressRepo = (signal) => {

  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
    signal: signal
  };
  return fetch("https://api.ipify.org?format=json", requestOptions)
};


export const getGeoLocationRepo = (params) => {
  return axios({
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_GEOLOCATION_API,
    params: params,
    withCredentials: false,
  })
};

export const postSignupRepo = (data) => {
  return axios({
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_SIGNUP_API,
    data: data,
  })
};

export const postLoginDataRepo = (data) => {
  return axios({
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.GET_LOGIN_API,
    data: data
  })
};

export const getCtaMessagingRepo = (params) => {
  return axios({
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_CTA_MESSAGING_API,
    params: params,
  })
};

export const getTertiaryCheckboxRepo = (params) => {
  return axios({
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_REGISTRATION_TERTIARY_CHECKBOX_API,
    params: params,
  })
};

export const postUpdateProfileRepo = (data) => {
  return axios({
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_REGISTRATION_UPDATE_PROFILE_API,
    data: data
  })
};

export const getUserInfoRepo = (params) => {
  return axios({
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.USER_INFO_API,
    params: params,
  })
};

export const postUserProfileClevertapRepo = (data) => {
  return axios({
    baseURL: RegisterServiceUrls.REGISTER_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_CLEVERTAP_USER_PROFILE_API,
    data: data
  })
};